import { render, staticRenderFns } from "./baseBreadCrumb.vue?vue&type=template&id=12c242f4&scoped=true"
import script from "./baseBreadCrumb.vue?vue&type=script&lang=js"
export * from "./baseBreadCrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c242f4",
  null
  
)

export default component.exports